import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { RecommendationService } from "../services/RecommendationService";

export default function AuthorPanel({ article, related }) {
  const { user } = useContext(AuthContext);
  const [viewStartTime, setViewStartTime] = useState(null);
  
  // Track article view time
  useEffect(() => {
    if (article && user) {
      // Record when the user started viewing the article
      const startTime = Date.now();
      setViewStartTime(startTime);
      
      // Track the view interaction
      RecommendationService.trackInteraction(
        user.username,
        article.id,
        'view',
        0
      );
      
      // When component unmounts, track the view duration
      return () => {
        if (startTime) {
          const duration = Math.floor((Date.now() - startTime) / 1000); // duration in seconds
          RecommendationService.trackInteraction(
            user.username,
            article.id,
            'view_duration',
            duration
          );
        }
      };
    }
  }, [article, user, viewStartTime]); // Fixed dependency array
  
  // Track related article clicks
  const handleRelatedClick = (relatedArticle) => {
    if (user && relatedArticle) {
      RecommendationService.trackInteraction(
        user.username,
        relatedArticle.id,
        'related_click'
      );
    }
  };

  return (
    <div className="w-72 bg-white h-[calc(100vh-4rem)] p-4 border-l
                    flex flex-col fixed top-16 right-0 overflow-y-auto">
      <h3 className="text-lg font-serif mb-4">About the Author</h3>
      <p className="text-sm text-gray-700 mb-6">{article.author}</p>

      {related.length > 0 && (
        <>
          <h3 className="text-lg font-serif mb-4">Related Articles</h3>
          <div className="space-y-4">
            {related.map((relatedArticle) => (
              <div key={relatedArticle.slug || relatedArticle.articleId} className="border-b pb-2">
                <Link 
                  to={`/article/${relatedArticle.slug || relatedArticle.articleId}`} 
                  className="text-sm font-medium hover:text-taupe-dark"
                  onClick={() => handleRelatedClick(relatedArticle)}
                >
                  {relatedArticle.title}
                </Link>
                <p className="text-xs text-gray-500 mt-1">
                  By {relatedArticle.author}
                </p>
                
                {/* Show recommendation badge if it's from the recommendation engine */}
                {relatedArticle.articleId && (
                  <div className="mt-1">
                    <span className="px-2 py-0.5 bg-taupe text-white text-xs rounded-full">
                      Recommended
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}